// jitsiDefaults.ts
import type { JitsiMeetingSettingKeys } from './jitsiSettings';

export const jitsiDefaultSettings: Partial<Record<JitsiMeetingSettingKeys, unknown>> = {
  'prejoinConfig.enabled': true,
  'analytics.disabled': false,
  audioLevelsInterval: 200,
  defaultLocalDisplayName: '',
  disableShortcuts: false,
  resolution: 720,
  toolbarButtons: [],
  startWithVideoMuted: false,
  startWithAudioMuted: false,
  subject: '',
  constraints: {},
  notifications: {},
  'p2p.enabled': true,
  'whiteboard.enabled': false,
  apiLogLevels: ['error', 'warn', 'log', 'info', 'debug'],
};
